// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallPreview__container-c0b485 {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}

.CallPreview__fixed-container-eb7f68 {
  min-height: auto;
  overflow: hidden;
}

.CallPreview__content-da9312 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
}

.CallPreview__backgroundContainer-e60327 {
  position: relative;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 4;
}

@media (max-width: 1024px) {
  .CallPreview__content-da9312 {
    flex-direction: column;
  }
}
@media (max-width: 1024px) {
  .CallPreview__content-da9312 {
    flex-direction: column;
    width: 100%;
    max-width: 380px;
    align-self: center;
  }
}
@media (max-width: 768px) {
  .CallPreview__content-da9312 {
    justify-content: space-around;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/CallPreview/CallPreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACF;;AACA;EACE,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,OAAA;AAEF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;AAEF;;AAAA;EACE;IACE,sBAAA;EAGF;AACF;AAAA;EACE;IACE,sBAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;EAEF;AACF;AACA;EACE;IACE,6BAAA;EACF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n}\n.fixed-container {\n  min-height: auto;\n  overflow: hidden;\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  flex: 1;\n}\n\n.backgroundContainer {\n  position: relative;\n  right: 0;\n  top: 0;\n  height: 100%;\n  z-index: 4;\n}\n@media (max-width: 1024px) {\n  .content {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 1024px) {\n  .content {\n    flex-direction: column;\n    width: 100%;\n    max-width: 380px;\n    align-self: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .content {\n    justify-content: space-around;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallPreview__container-c0b485`,
	"fixed-container": `CallPreview__fixed-container-eb7f68`,
	"fixedContainer": `CallPreview__fixed-container-eb7f68`,
	"content": `CallPreview__content-da9312`,
	"backgroundContainer": `CallPreview__backgroundContainer-e60327`
};
module.exports = ___CSS_LOADER_EXPORT___;
